// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import vimeoWidget from './js/widgets/vimeoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import seoImagesWidget from './js/widgets/seoImagesWidget.js';
import seoTextWidget from './js/widgets/seoTextWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import youtubeWidget from './js/widgets/youtubeWidget.js';
import videoImageWidget from './js/widgets/videoImageWidget.js';
import locationsButton from './js/widgets/locationsButton.js';
import footerContact from './js/widgets/footerContact.js';
import subpageBackground from './js/widgets/subpageBackground.js';
import footerBackground from './js/widgets/footerBackground.js';

// Custom Theme Scripts
import './js/localjs';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    vimeoWidget();
    multiScheduleFeature();
    seoImagesWidget();
    seoTextWidget();
    cardWidget();
    videoImageWidget();
    locationsButton();
  });
  $(window).load(() => {
    youtubeWidget();
  });
}

$(document).ready(() => {
  footerBackground();
  footerContact();
});
$(window).load(() => {
  subpageBackground();
});
